import React from 'react';

import { Thumbnail } from '../../Thumbnail';

import { Action, Content, Name, SupplyLabel, ThumbnailWrapper } from './FilterCollection.style.ts';
import { tokens } from './FilterCollection.tokens.ts';

// Many of the types used here are derived from the GraphQL `Collection`.
// import { type Collection } from '@pkg/graphql/codegen/graphql';
// type MarketSupply = NonNullable<Collection['marketData']>['totalSupply'];

export interface FilterCollectionProps {
    id: string;
    name: string;
    imageUrl?: string;
    // TODO: This value should only be a `number`.
    // It is derived from the MarketSupply type above.
    totalSupply?: string | number;
    disabled?: boolean;
    pressed?: boolean;
    onSelect?: (id: string) => void;
}

export function FilterCollection({
    id,
    name,
    imageUrl,
    totalSupply,
    disabled = false,
    pressed = false,
    onSelect,
}: FilterCollectionProps) {
    function handleSelect() {
        onSelect?.(id);
    }

    const supplyMarkup = totalSupply ? (
        <SupplyLabel>
            <strong>{totalSupply}</strong> assets
        </SupplyLabel>
    ) : null;

    return (
        <Action ariaLabel="Toggle this collection" disabled={disabled} pressed={pressed} onAction={handleSelect}>
            <Content>
                <ThumbnailWrapper>
                    <Thumbnail imageUrl={imageUrl} mashWidth={tokens.thumbnail.size * 2} />
                </ThumbnailWrapper>

                <Name>{name}</Name>
            </Content>

            {supplyMarkup}
        </Action>
    );
}
